import React from 'react';
import { Bell, Settings, User, HelpCircle, Plus } from 'lucide-react';
export function Header() {
  return <header className="bg-white border-b border-gray-200" data-id="element-307">
      <div className="max-w-7xl mx-auto px-6" data-id="element-308">
        
      </div>
    </header>;
}